module.exports = __webpack_public_path__ + "static/media/icon-error-web.1eb11c7e.svg";